(function () {
  'use strict';

  function initializePromoBar(bar) {
    let slides = Array.from(bar.querySelectorAll('.js-promo-slide'));
    let activeIndex = 0;
    const desktop = window.matchMedia('(min-width: 1200px)');
    let rotationTimer;
    let countdownTimer;
    const rotationSpeed = Number.parseInt(bar.dataset.rotationSpeed, 10) || 5000;
    const slideList = bar.querySelector('.promo-bar__slides');
    // Desktop shows every slide side by side while they fit. In long languages
    // (French, German) the row is wider than the space next to the utility
    // actions; then the bar rotates one slide at a time, like the mobile strip.
    let fitsSideBySide = true;

    function isRotating() {
      return !desktop.matches || !fitsSideBySide;
    }

    // Measures the side-by-side row in one synchronous pass: the rotating class
    // is removed, the natural row width is read and the class is set again
    // before the browser paints, so the bar never visibly switches layout.
    function measureFit() {
      if (!desktop.matches || !slideList) {
        fitsSideBySide = true;
        bar.classList.remove('promo-bar--rotating');
        return;
      }
      bar.classList.remove('promo-bar--rotating');
      fitsSideBySide = slideList.scrollWidth <= slideList.clientWidth;
      bar.classList.toggle('promo-bar--rotating', !fitsSideBySide);
    }

    function updateLayout() {
      const wasRotating = isRotating();
      measureFit();
      showSlide(activeIndex);
      if (isRotating() !== wasRotating) startRotation();
    }

    function showSlide(index) {
      if (slides.length === 0) return;
      activeIndex = ((index % slides.length) + slides.length) % slides.length;
      const rotating = isRotating();
      slides.forEach(function (slide, slideIndex) {
        const isActive = !rotating || slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    }

    function stopRotation() {
      window.clearInterval(rotationTimer);
    }

    function startRotation() {
      stopRotation();
      if (slides.length > 1 && isRotating()) {
        rotationTimer = window.setInterval(function () {
          showSlide(activeIndex + 1);
        }, rotationSpeed);
      }
    }

    function removeExpiredCampaign(campaign) {
      const wasActive = !campaign.hidden;
      campaign.remove();
      slides = Array.from(bar.querySelectorAll('.js-promo-slide'));
      if (wasActive || activeIndex >= slides.length) activeIndex = 0;
      window.clearInterval(countdownTimer);
      measureFit();
      showSlide(activeIndex);
      startRotation();
    }

    function initializeCampaign() {
      const campaign = bar.querySelector('.js-campaign-slide');
      if (!campaign) return;

      const endTime = new Date(campaign.dataset.campaignEnd).getTime();
      const countdown = campaign.querySelector('.js-countdown');
      if (!Number.isFinite(endTime)) {
        removeExpiredCampaign(campaign);
        return;
      }

      function updateCountdown() {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          removeExpiredCampaign(campaign);
          return;
        }
        if (!countdown) return;

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        countdown.querySelector('.js-days').textContent = String(days);
        countdown.querySelector('.js-hours').textContent = String(hours).padStart(2, '0');
        countdown.querySelector('.js-minutes').textContent = String(minutes).padStart(2, '0');
      }

      updateCountdown();
      countdownTimer = window.setInterval(updateCountdown, 60000);
    }

    desktop.addEventListener('change', updateLayout);
    if (typeof window.ResizeObserver === 'function' && slideList) {
      // Only a width change can change the fit; a rotating slide that wraps
      // changes the height and must not trigger a new measurement.
      let observedWidth = slideList.clientWidth;
      new window.ResizeObserver(function () {
        const width = slideList.clientWidth;
        if (width === observedWidth) return;
        observedWidth = width;
        updateLayout();
      }).observe(slideList);
    }
    // Web fonts change the text width without resizing the bar.
    if (document.fonts?.ready) document.fonts.ready.then(updateLayout);
    bar.addEventListener('mouseenter', stopRotation);
    bar.addEventListener('mouseleave', startRotation);
    bar.addEventListener('focusin', stopRotation);
    bar.addEventListener('focusout', startRotation);
    bar.addEventListener('click', function (event) {
      const button = event.target.closest('.js-copy-code');
      if (!button) return;

      const code = button.dataset.code;
      if (!code || !navigator.clipboard?.writeText) return;
      navigator.clipboard.writeText(code).then(function () {
        const originalLabel = button.textContent;
        button.textContent = button.dataset.copiedLabel;
        window.setTimeout(function () {
          button.textContent = originalLabel;
        }, 2000);
      });
    });

    measureFit();
    showSlide(0);
    initializeCampaign();
    startRotation();
  }

  function initialize() {
    document.querySelectorAll('.js-promo-bar').forEach(initializePromoBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
